import { render, staticRenderFns } from "./BvaAbusingReportAction.vue?vue&type=template&id=83a4e9ac&scoped=true&"
import script from "./BvaAbusingReportAction.vue?vue&type=script&lang=ts&"
export * from "./BvaAbusingReportAction.vue?vue&type=script&lang=ts&"
import style0 from "./BvaAbusingReportAction.vue?vue&type=style&index=0&id=83a4e9ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a4e9ac",
  null
  
)

export default component.exports